// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-card[data-v-e758f3d0]:not(.selected):hover {\r\n  background-color: #edf5ff;\n}\n.selected[data-v-e758f3d0] {\r\n  background-color: #edf5ff;\n}\r\n", ""]);
// Exports
module.exports = exports;
